var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppSavedObjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oui:app-saved-objects"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.285 5.25075L12.75 7.21425V0H11.25V7.21425L8.7225 5.25075L7.785 6.3855L12 9.6585L16.2225 6.3855L15.285 5.25075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.795 0.12375L14.9625 1.33125L21.9 5.8185L12 12.2175L2.1 5.8185L9.0375 1.33125L8.2125 0.12375L0 5.4255V15.6652L12 23.418L24 15.6652V5.4255L15.795 0.12375ZM1.5 7.1775L11.25 13.4827V21.192L1.5 14.88V7.1775ZM12.75 21.1845V13.4835L22.5 7.17825V14.8875L12.75 21.1845Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppSavedObjects);
export default __webpack_public_path__ + "static/media/app-saved-objects.cbfba100ec80e95e582a7eca5fb20193.svg";
export { ForwardRef as ReactComponent };